import React from 'react';
import { ReadOnlyInputs } from '../QsrDept.styles';
import Input from '../../../components/Input/Input';
import { StyledButtons } from '../../RawProdGINs/RawProdGins.style';
import Button from '../../../components/Button/Button';
import { RemoveQsrXrefModalProps } from './QsrModal.types';
import Modal from '../../../components/Modal/Modal';
import { Variant } from '../../../components/Button/Button.types';

export const RemoveQsrXrefModal = ({ open, onClose, onCancel, onConfirm, selectedQsrDeptXref }: RemoveQsrXrefModalProps): JSX.Element => {

  return (
    <Modal id="removeQsrDeptXrefModal" open={open} onClose={onClose} title="Remove QSR Department Xref">
      <div>
        <ReadOnlyInputs>
          <Input
            label="Department"
            disabled
            id="department"
            value={selectedQsrDeptXref?.department}
          />
          <Input
            label="Class"
            disabled
            id="class"
            value={selectedQsrDeptXref?.classDescription}
          />
        </ReadOnlyInputs>
        <ReadOnlyInputs>
          <Input
            label="Base"
            disabled
            id="base"
            value={selectedQsrDeptXref?.baseDescription}
          />
          <Input
            label="Size"
            disabled
            id="size"
            value={selectedQsrDeptXref?.sizeDescription}
          />
          <Input
            label="Prod"
            disabled
            id="prod"
            value={selectedQsrDeptXref?.prodDescription}
          />
        </ReadOnlyInputs>
        <StyledButtons>
          <Button label="Cancel" testId="closeModalButton" onClick={onCancel} variant={Variant.Secondary} />
          <Button label="Delete" testId="RemoveQsrXrefRecord" onClick={onConfirm} variant={Variant.Primary} />
        </StyledButtons>
      </div>
    </Modal>
  );
};

export default RemoveQsrXrefModal;
